<template>
  <v-chart class="chart" :option="option" />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: "gauge",
  components: {
    VChart,
  },
  //背景颜色
  provide: {
    [THEME_KEY]: "",
  },
  props: {
    value: {
      type: Array,
    },
    legend: {
      type: Array,
    },
  },
  data() {
    return {
      option: {
        tooltip: {
          trigger: "axis",
        //   axisPointer: {
        //     type: "cross",
        //     crossStyle: {
        //       color: "#555",
        //     },
        //   },
        },
        title:{
            text:'产线电量统计',
            left:'35%',
            textStyle:{
                fontSize:15,
                color:'#fff'
            }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        legend: {
          top: 25,
          right:15,
          data: this.legend,
          textStyle: {
            fontSize: 10,
            color: "#fff",
          },
          itemWidth: 10,
          itemHight: 5,
          icon:'circle'
        },
        xAxis: [
          {
            type: "category",
            data: ["电科道", "模冷风机", "退火炉"],
            axisPointer: {
              type: "shadow",
            },
            interval: 15,
            minorTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            // name: "Precipitation",
            // data: [0, 15, 30, 45, 60],
            min: 0,
            max: 60,
            interval: 15,
            axisLabel: {
              formatter: "{value} 度",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: this.value,
      },
    };
  },
  watch:{
    value(newVal) {
      this.option.series = newVal
    },
    legend(newVal) {
      this.option.legend.data = newVal
    }
  }
};
</script>

<style scoped>
.chart {
  width: 400px;
  height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/test10Children/productele.vue